import { DateInputField, DateInputOptions } from "./form-field/date-input";
import { TextInputField, TextInputOptions } from "./form-field/text-input";
import { DropdownInputField, DropdownInputOptions } from "./form-field/dropdown-input";
import { FileUploadInputField, FileUploadInputOptions } from "./form-field/file-upload";
import { NumberInputField, NumberInputOptions } from "./form-field/number-input";
import { MultiAddInputField, MultiAddInputOptions } from "./form-field/multi-add-input";
import { PickListItem, JsonItem } from "../../entities/pick-list/pick-list.entities";

export {
    DateInputField, DateInputOptions,
    TextInputField, TextInputOptions,
    DropdownInputField, DropdownInputOptions,
    FileUploadInputField, FileUploadInputOptions,
    NumberInputField, NumberInputOptions,
    MultiAddInputField, MultiAddInputOptions,
    PickListItem, JsonItem
}

export interface IFormField {
    fieldId: string; // Id of HTML element/block
    displayName: string; // Display label
    isRequired: boolean;
    propertyName: string; // property name of data element (dot notation)
    defaultVal: any; // used if no value or invalid
    formSection: IFormSection; // used to allow field to trigger events in the section

    forObjProperty: boolean; // used to know if a field should be used to update form entity (false for file uploads, true for pretty much everything else)

    shouldTriggerUpdate: boolean; // don't fire any update events until specified

    initialize(...args: any[]); // initializes field
    getValue(): any; // get current value of form field
    setValue(data: any); // set or prepopulate value
    checkChanged(): boolean; // check if current val is different default val;
    checkValid(): boolean; // is input valid;
    displayValid(isValid: boolean); // update display for if entry if valid or not
    resetValidDisplay(); // reset any display validation
    triggerSectionUpdate(); // Triggers Section update

}

export interface IFormSection {
    sectionId: string; // Id of the HTML section block
    displayName: string; // Name that appears in sidebar
    formFields: IFormField[]; // form fields within the section
    form: IForm; // form section links with form
    pickLists: JsonItem[]; // used for generating form fields - from IForm

    updateSection(); // triggered by form field, initiates check to see if section is (Not Started, In Progress, Completed)
    triggerFormUpdate(); // triggered by form section, initiates changes in form elements
    initialize(form: IForm); // initializes each section with information fed from top level
    getSectionStatus(): SectionStatus; // get status of section
}

export interface IForm {
    formSections: IFormSection[]; // form sections for the form
    pickLists: JsonItem[];
    currentItem: any; // item being currently edited/viewed
    defaultItem: any; // default item to be used for invalid or not entered fields

    updateForm(); // 
}

export enum SectionStatus {
    "NotStarted",
    "InProgress",
    "Complete"
}